import { render, staticRenderFns } from "./salle-examen.html?vue&type=template&id=0b2d88ce&scoped=true&external"
import script from "./salle-examen.js?vue&type=script&lang=js&external"
export * from "./salle-examen.js?vue&type=script&lang=js&external"
import style0 from "./salle-examen.scss?vue&type=style&index=0&id=0b2d88ce&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d88ce",
  null
  
)

export default component.exports